const allENV = {
  local: {
    baseURL: "http://localhost:3004/api/v2",
    ipURL: "https://api.ipstack.com",
    name: 'local'
  },
  visilant: {
    baseURL: "https://devapi.visilant.org/api/v2",
    ipURL: "https://api.ipstack.com",
    name: 'visilant'
  },
  pndy: {
    baseURL: "https://pndyapi.visilant.org/api/v2",
    ipURL: "https://api.ipstack.com",
    name: 'pndy'
  },
  img: {
    baseURL: "https://imgapi.visilant.org/api/v2",
    ipURL: "https://api.ipstack.com",
    name: 'img'
  },
  snc: {
    baseURL: "https://sncapi.visilant.org/api/v2",
    ipURL: "https://api.ipstack.com",
    name: 'snc',
  },
  sceh: {
    baseURL: "https://scehapi.visilant.org/api/v2",
    ipURL: "https://api.ipstack.com",
    name: 'sceh'
  }
};

function getTenantId() {
  if (typeof window !== 'undefined' && window.location?.hostname) {
    const host = window.location.hostname;
    if (host === 'localhost' || host.startsWith('127.')) return process.env.REACT_APP_ENV_NAME || 'local';
    return host.split('.')[0];
  }
  return process.env.REACT_APP_ENV_NAME || 'local';
}

function detectEnv() {
  const tenantId = getTenantId();

  if (process.env.REACT_APP_API_BASE_URL) {
    return {
      baseURL: process.env.REACT_APP_API_BASE_URL,
      ipURL: "https://api.ipstack.com",
      name: tenantId,
      tenantId
    };
  }

  if (typeof window !== 'undefined' && window.location?.hostname) {
    const host = window.location.hostname;
    if (host === 'localhost' || host.startsWith('127.') || host.endsWith('.localhost')) return { ...allENV.local, tenantId };
    if (host.includes('pndy')) return { ...allENV.pndy, tenantId };
    if (host.includes('img')) return { ...allENV.img, tenantId };
    if (host.includes('snc')) return { ...allENV.snc, tenantId };
    if (host.includes('sceh')) return { ...allENV.sceh, tenantId };
    if (host.includes('visilant')) return { ...allENV.visilant, tenantId };
  }

  return { ...allENV.local, tenantId };
}

function isValidTenant() {
  if (typeof window !== 'undefined' && window.location?.hostname) {
    const host = window.location.hostname;
    if (host.startsWith('127.')) return true;
    if (host.endsWith('.localhost')) return true;
    if (host === 'localhost') return false;
    return host.split('.').length >= 3;
  }
  return false;
}

export const Server = {
  ENV: detectEnv(),
  isValidTenant: isValidTenant()
};
